import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
/**
 * @Description This function lets you return Logging.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Logging() {
    const { t } = useTranslation();
    const label = 'CONTENT.SETTINGS.GENERAL.';
    const [file, setFile] = useState();
    const handleFileChange = (e) => {
        setFile(e.target.files[0]?.name);
    }
    return (
        <div className="sgeneral-logging">
            <div>
                <div>{t(label + 'LOG-PATH')}</div>
                <div className="custom-file">
                    <input type="file" className="custom-file-input" id="sgeneral-customFile" onChange={handleFileChange}/>
                    <label className="custom-file-label" htmlFor="sgeneral-customFile">{file ? file : t(label + 'CHOOSE')}</label>
                </div>
            </div>
            <div>
                <div>{t(label + 'LOG-LEVEL')}</div>
                <div className="sgeneral-loglevel">
                    <div>{t(label + 'INFORMATION')}</div>
                    <div>{t(label + 'WARNING')}</div>
                    <div>{t(label + 'ERROR')}</div>
                </div>
            </div>
        </div>
    )
}
export default Logging;